import React from "react";

import "./trend_Health.css";

const Trend_Health = () => (
  <svg id="Trend_Health" data-name="Trend  Health" xmlns="http://www.w3.org/2000/svg" width="32.001" height="32.001" viewBox="0 0 32.001 32.001">
    <g id="Trend_Health-2" data-name="Trend  Health" transform="translate(16 16)">
      <g id="Group_8884" data-name="Group 8884" transform="translate(-16 -16)">
        <rect id="Rectangle_367" data-name="Rectangle 367" className="Trend-1" width="32.001" height="32.001" />
        <path
          id="Path_8727"
          data-name="Path 8727"
          className="Trend-2"
          d="M14.338,19.854a.53.53,0,0,1-.472-.291L12.354,16.53H8V15.491h4.676a.513.513,0,0,1,.461.285l1.2,2.393,2.854-5.718a.555.555,0,0,1,.93,0l1.525,3.04H24V16.53H19.325a.512.512,0,0,1-.461-.285l-1.2-2.393L14.8,19.569A.512.512,0,0,1,14.338,19.854Z"
        />
      </g>
    </g>
  </svg>
);

export default Trend_Health;
